import React, { Component } from 'react';
import { connect } from 'react-redux';

import './ViralBoosters.css';
import Cookies from 'universal-cookie';
import { updateVBPInner } from '../../actions/CompetitionActions';

class ViralBoosters extends Component {

    constructor(props) {

        super(props);
        this.state = {};
        this.triggerVBooster = this.triggerVBooster.bind(this);
    }

    triggerVBooster = (vBooster) => {
        console.log('vBooster', vBooster);
        console.log('vBooster-props', this.props);

        if (vBooster.ctaLink && vBooster.ctaLink != "") {
            window.open(vBooster.ctaLink, '_blank');
        }

        if (vBooster.idCompetition && vBooster.id && this.props.competition
          && this.props.competition.data && this.props.competition.data.id) {
            let idComp = this.props.competition.data.id;
            let localContext = `${idComp}-`;
            let token = localStorage.getItem(localContext + 'token');
            if (token) {
              var params = {
                idComp: vBooster.idCompetition,
                idCompVB: vBooster.id,
              }

              this.props.dispatch(
                updateVBPInner(
                  idComp,
                  token,
                  params,
                  this.props.dispatch
                )
              );

              // const cookies = new Cookies();
              // cookies.set('vBEntries-' + vBooster.idCompetition, vBEntriesExisting);

              // var vBEntries = cookies.get('vBEntries-' + vBooster.idCompetition);

            }
        }
    }

    render() {

        const { currentRound, data } = this.props.competition;

        // let marketingButtons = (
        //     <div
        //         style={{backgroundColor: data ? data.secondaryColor : '', color: data ? data.primaryColor : ''}}
        //         className='marketing-buttons'>
        //     </div>
        // );
        
        let confirmationCopy = null;

        if (data && data.thanksCopy && data.thanksCopy != '' && this.props.competition.submitted
          && this.props.competition.submittedIdInterval === currentRound.id) {

          confirmationCopy = (
            <div className="row">
                <div className="col-sm-12">
                  <p style={{color: data.primaryColor ? data.primaryColor : '#FFFFFF'}}
                    className={'thanks-copy'} dangerouslySetInnerHTML={{__html: data.thanksCopy}} />
                </div>
            </div>
          );
        }

        let viralBoosters = null;

        if (data && data.isViralSharingEnabled && data.viralBoosters && data.viralBoosters.length
            && this.props.competition.submitted && this.props.competition.submittedIdInterval === currentRound.id) {

            viralBoosters = (

                <div className="row">
                    <div className="col-sm-12">
                        <div className="v-booster-section row">
                            {data.drawCopy && data.drawCopy != '' ? <div className="row v-b-info">
                                <span
                                    style={{
                                        color: data.primaryColor ? data.primaryColor : '#FFFFFF'
                                    }}
                                    dangerouslySetInnerHTML={{__html: data.drawCopy}}>
                                </span>
                            </div> : ''}
                            {data.viralBoosters.map((vb, vbIndex) =>
                                <div className="v-booster" style={{
                                    backgroundColor: vb.buttonColor ? vb.buttonColor : '#808080',
                                    color: vb.textColor ? vb.textColor : '#FFFFFF',
                                }} onClick={() => this.triggerVBooster(vb)}
                                    key={vbIndex}>
                                    {vb.image ? <img src={vb.image.file} /> : ''}
                                    <span className="v-b-text">{vb.ctaText}</span>
                                    {/* <span className="v-b-p-added">
                                            <img src="https://benchvote-media-assets.s3.ap-southeast-2.amazonaws.com/common-images/icons/tick_green.png" />
                                        </span> */}
                                </div>
                            )}
                        </div>

                    </div>
                </div>

            );
        }

        return currentRound ? <>
            {confirmationCopy}
            {viralBoosters}
          </> : <>
            {confirmationCopy}
            {viralBoosters}
          </>;
    }
}

//-------------------------------------------------------------------------
//-------------------- Mapping store to App's props ----------------------
//-------------------------------------------------------------------------

const mapStateToProps = (state, ownProps) => {

    const things = state.default;
    return {
        ...ownProps,
        competition: things.competition,
        locale: things.locale
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ViralBoosters);
